import { useState, useEffect } from 'react';
import '../../entrydoor.css';

// Single leaf pull direction:
//   Left to Right -> mesh anchored on the left jamb, handle bar closes on the right jamb
//   Right to Left -> mesh anchored on the right jamb, handle bar closes on the left jamb
export const LEFT_TO_RIGHT = 'Left to Right';
export const RIGHT_TO_LEFT = 'Right to Left';

export const SCREEN_ORIENTATIONS = [
    { id: 1, value: LEFT_TO_RIGHT, label: 'Left to Right' },
    { id: 2, value: RIGHT_TO_LEFT, label: 'Right to Left' },
];

export const getScreenOrientation = (value) =>
    SCREEN_ORIENTATIONS.find(o => o.value === value) || SCREEN_ORIENTATIONS[0];

const ScreenOrientation = ({ value, onChange, id = 'ScreenOrientation', label = 'Orientation', disabled = false }) => {
    const [selectedOrientation, setSelectedOrientation] = useState(value || '');

    useEffect(() => {
        setSelectedOrientation(value || '');
    }, [value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (!selectedOrientation) {
            const defaultOption = SCREEN_ORIENTATIONS[0];
            setSelectedOrientation(defaultOption.value);
            onChange(defaultOption.value);
        }
    }, []);

    const handleOrientationChange = (e) => {
        const option = getScreenOrientation(e.target.value);
        setSelectedOrientation(option.value);
        onChange(option.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedOrientation}
                onChange={handleOrientationChange}
            >
                {SCREEN_ORIENTATIONS.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedOrientation === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ScreenOrientation;
